var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0152 0.394531C24.4369 0.394533 26.0342 11.4869 26.0342 11.4869L26.0627 22.9784H50.4715V26.4287H16.3676C16.3676 26.4287 0 24.5725 0 50.3813C-1.82431e-06 76.1901 14.286 75.2748 14.286 75.2748H22.812V63.2985C22.812 63.2985 22.3524 49.0125 36.8698 49.0125H61.0791C61.0791 49.0125 74.6807 49.2324 74.6807 35.8671V13.768C74.6807 13.768 76.7458 0.394531 50.0152 0.394531ZM36.5562 8.12209C38.9847 8.12208 40.9475 10.0849 40.9475 12.5134C40.9475 14.9419 38.9847 16.9047 36.5562 16.9047C34.1277 16.9047 32.1649 14.9419 32.1649 12.5134C32.1649 10.0849 34.1277 8.12209 36.5562 8.12209Z",
    fill: "url(#paint0_linear_30_368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7417 100.627C76.32 100.627 74.7228 89.5347 74.7228 89.5347L74.6943 78.0431H50.2854V74.5928H84.3893C84.3893 74.5928 100.757 76.4491 100.757 50.6403C100.757 24.8315 86.4709 25.7467 86.4709 25.7467H77.945V37.723C77.945 37.723 78.4045 52.009 63.8871 52.009H39.6779C39.6779 52.009 26.0762 51.7891 26.0762 65.1544V87.2535C26.0762 87.2535 24.0111 100.627 50.7417 100.627ZM64.2007 92.8994C61.7722 92.8994 59.8094 90.9366 59.8094 88.5081C59.8094 86.0796 61.7722 84.1168 64.2007 84.1168C66.6292 84.1168 68.5921 86.0796 68.5921 88.5081C68.5921 90.9366 66.6292 92.8994 64.2007 92.8994Z",
    fill: "url(#paint1_linear_30_368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_368",
    x1: 9.68293,
    y1: 9.41015,
    x2: 59.6144,
    y2: 58.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_368",
    x1: 40.3309,
    y1: 41.1533,
    x2: 93.952,
    y2: 91.8429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.8f980b85c59a46f35cece9d99f66682c.svg";
export { ForwardRef as ReactComponent };